import { getDateForIms } from 'js/hooks/useFormatter/helpers';

export const intoDate = date => typeof date === 'number' ? new Date(date) : new Date(date.getTime());

export const startOfDay = (date = new Date()) => {
    const anotherDate = new Date(date.valueOf());

    anotherDate.setHours(0, 0, 0, 0);

    return anotherDate;
};

export const endOfDay = (date = new Date()) => {
    const anotherDate = new Date(date.valueOf());

    anotherDate.setHours(23, 59, 59, 0);

    return anotherDate;
};

export const formatDateForIms = time => {
    const timeRaw = time ? new Date(time) : new Date();

    timeRaw.setMilliseconds(0);

    return getDateForIms(timeRaw);
};

export const hasYearsDiffStrict = (from, until, diff) => {
    const date = new Date(from);

    date.setFullYear(from.getFullYear() + diff);

    return date.getTime() <= until.getTime();
};
